export default __webpack_public_path__ + "static/media/prefarm.8ffc1f06.png";